import dispatcher from "../dispatchers/dispatcher";
import LoginWebAPIUtils from "../utils/loginWebAPIUtils";

export function setUserName(inputValue) {
    dispatcher.dispatch({
        type: "SET_USER_NAME",
        value: inputValue
    });
}
export function setAnyKey(key, inputValue, mobile_extension) {
    dispatcher.dispatch({
        type: "SET_ANY_KEY",
        key: key,
        value: inputValue,
        extra: mobile_extension
    });
}
export function passwordMsg(key, inputValue) {
    dispatcher.dispatch({
        type: "SET_ANY_KEY",
        key: key,
        value: inputValue
    });
}
export function removeUserName(inputValue) {
    dispatcher.dispatch({
        type: "DELETE_USER_NAME",
        value: inputValue
    });
}

export function preLoginApi(query, activeTab) {
    dispatcher.dispatch({
        type: "SET_ANY_KEY",
        key: "user",
        value: query.user,
        extra: query.mobile_extension,
        activeTab
    });
    LoginWebAPIUtils._preLoginApi(query);
}

export function loginApi(query, withOtp) {
    LoginWebAPIUtils._loginApi(query, withOtp);
}

export function sendOTPApi(query) {
    LoginWebAPIUtils._sendOTPApi(query);
}

export function validateOTPApi(query) {
    LoginWebAPIUtils._validateOTPApi(query);
}

export function verifyEmailApi(query, loader) {
    LoginWebAPIUtils._verifyEmailApi(query, loader);
}

export function registrationAPI(query, is_super_user) {
    LoginWebAPIUtils._registrationAPI(query, is_super_user);
}

export function setPassword(query) {
    LoginWebAPIUtils._setPassword(query);
}
export function _checkSSO(query) {
    LoginWebAPIUtils._checkSSO(query);
}
export function getCountryCodeTypeaheadAPI() {
    LoginWebAPIUtils._getCountryCodeTypeaheadAPI();
}
export function verifyEmailId(query, successCB, failCB) {
    LoginWebAPIUtils._verifyEmailId(query, successCB, failCB);
}
